import { PaymentMethod } from '@stripe/stripe-js'
import { PaymentMethodPresentationMode } from '@dtx-company/app/shared/common/src/components/PlanPurchaseExperience/components/PaymentMethodDisplay'
import { capitalize } from '@dtx-company/true-common/src/utils/strings'
import { paymentTypes } from '@dtx-company/app/shared/code/src/constants/account'

export const getDefaultPaymentMethodMainText = (
  paymentMethod: PaymentMethod,
  mode: PaymentMethodPresentationMode
): string => {
  switch (true) {
    case !!paymentMethod.card:
      return cardPaymentMethodMainText(paymentMethod.card, mode)
    case paymentMethod.type === 'us_bank_account' && !!paymentMethod.us_bank_account:
      return achPaymentMethodMainText(paymentMethod.us_bank_account, mode)
    case paymentMethod.type === 'ideal' && !!paymentMethod.ideal:
      return idealPaymentMethodMainText(paymentMethod.ideal, mode)
    case paymentMethod.type === 'sepa_debit' && !!paymentMethod.sepa_debit:
      return sepaPaymentMethodMainText(mode)
    default:
      return paymentTypes[paymentMethod.type] || paymentMethod.type
  }
}

const sepaPaymentMethodMainText = (mode: PaymentMethodPresentationMode): string => {
  return mode === 'short' ? 'SEPA' : paymentTypes['sepa_debit']
}

const idealPaymentMethodMainText = (
  account: PaymentMethod['ideal'],
  mode: PaymentMethodPresentationMode
): string => {
  return mode === 'default' ? `${paymentTypes['ideal']} (${account?.bank})` : paymentTypes['ideal']
}

const achPaymentMethodMainText = (
  account: PaymentMethod['us_bank_account'],
  mode: PaymentMethodPresentationMode
): string => {
  switch (mode) {
    case 'default':
      return `${account?.bank_name} xxxx${account?.last4}`
    case 'fullDescription':
      return account?.bank_name || ''
    case 'short':
      return `${account?.bank_name} (...${account?.last4})`
    case 'buyPlan':
      return `${account?.bank_name} ending in ${account?.last4}`
  }
}

const cardPaymentMethodMainText = (
  card: PaymentMethod['card'],
  mode: PaymentMethodPresentationMode
): string => {
  switch (mode) {
    case 'default':
      return `xxxx ${card?.last4}`
    case 'fullDescription':
      return card?.last4 || ''
    case 'short':
      return `${paymentTypes[card?.wallet?.type || '']} (${capitalize(card?.brand || '')} ...${card?.last4})`
    case 'buyPlan':
      return `Ending in ${card?.last4 || ''}`
  }
}
